import React from 'react';
import Style from './Home.module.scss';
import me from '../../img/self.png';
import classNames from 'classnames';
import EmojiBullet from "./EmojiBullet";
import SocialIcon from "./SocialIcon";
import {Box} from "@mui/material";
import {info} from "../../info/Info";

export default function Home({innerRef}) {

   return (
      <Box ref={innerRef} component={'main'} display={'flex'} flexDirection={{xs: 'column', md: 'row'}} alignItems={'center'}
           justifyContent={'center'} minHeight={'calc(100vh - 175px)'} id={'home'}>
         <Box className={classNames(Style.avatar, Style.shadowed)} alt={'image of developer'} style={{background: info.gradient}} component={'img'} src={me} width={{xs: '35vh', md: '40vh'}}
              height={{xs: '35vh', md: '40vh'}}
              borderRadius={'50%'} p={'0.75rem'} mb={{xs: '1rem', sm: 0}} mr={{xs: 0, md: '2rem'}}/>
         <Box>
            <h1>Hi, I'm <span style={{background: info.gradient, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'}}>{info.firstName}</span><span className={Style.hand}>🤚</span>
            </h1>
            <Box display={'flex'} flexWrap={'wrap'} gap={'0.5rem'} mb={'0.6rem'} alignItems={'center'}>
               <span className={Style.roleBadge} style={{background: 'rgba(0,160,110,0.12)', border: '1px solid rgba(0,160,110,0.5)', color: 'rgb(0,130,85)'}}>
                  📱 iOS · Swift · SwiftUI
               </span>
               <span className={Style.roleBadge} style={{background: 'rgba(166,104,255,0.12)', border: '1px solid rgba(166,104,255,0.4)', color: 'rgb(166,104,255)'}}>
                  🌐 Full-Stack · MERN
               </span>
            </Box>
            <h2>I'm a Software Engineer.</h2>
            <Box component={'ul'} p={'0.8rem'}>
               {info.miniBio.map((bio, index) => (
                  <EmojiBullet key={index} emoji={bio.emoji} text={bio.text}/>
               ))}
            </Box>
            <Box display={'flex'} flexDirection={'column'} gap={'0.75rem'} alignItems={'center'}>
               <Box display={'flex'} gap={'1.5rem'} justifyContent={'center'} fontSize={{xs: '2rem', md: '2.5rem'}}>
                  {info.socials.map((social, index) => (
                     <SocialIcon key={index} link={social.link} icon={social.icon} label={social.label} />
                  ))}
               </Box>
               {info.resumeUrl && (
                  <a
                     href={info.resumeUrl}
                     target="_blank"
                     rel="noopener noreferrer"
                     className={Style.resumeBtn}
                     download
                  >
                     <i className="fa fa-file-text-o" aria-hidden="true" style={{marginRight: '0.5rem'}} />
                     Download Resume
                  </a>
               )}
            </Box>
         </Box>
      </Box>
   )
}
